import script from "./DeleteAccountVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountVerify.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountVerify.vue?vue&type=style&index=0&id=2a3f861f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a3f861f"]])

export default __exports__